<template>
    <el-footer>
        <div class="footer-box">
            <div class="footer">
                <el-row :gutter="50" type="flex" justify="end" style="padding-bottom: 30px;">
                    <el-col :span="6">
                        <div class="title">新闻动态</div>
                        <div class="text" v-for="(item, index) in categoryList" :key="index">
                            <router-link :to="{name:'News', params: {active: item.id}}">{{item.name}}</router-link>
                        </div>
                    </el-col>
                    <el-col :span="6">
                        <div class="title">咨询投诉</div>
                        <div class="text">
                            <router-link :to="{name:'Publicity', params: {}}">咨询投诉公示</router-link>
                        </div>
                        <div class="text">
                            <router-link :to="{name:'Consult', params: {active: 2}}">咨询投诉机制</router-link>
                        </div>
                        <div class="text">
                            <router-link :to="{name:'Consult', params: {active: 3}}">我要咨询</router-link>
                        </div>
                    </el-col>
                    <el-col :span="6">
                        <div class="title">评价公示</div>
                        <div class="text">
                            <router-link :to="{name:'Appraise', params: {active: 1}}">承运人评价</router-link>
                        </div>
                        <div class="text">
                            <router-link :to="{name:'Appraise', params: {active: 2}}">托运人评价</router-link>
                        </div>
                        <div class="text">
                            <router-link :to="{name:'Appraise', params: {active: 3}}">评价机制</router-link>
                        </div>
                        <div class="text">
                            <router-link :to="{name:'Appraise', params: {active: 4}}">退出机制</router-link>
                        </div>
                    </el-col>
                    <el-col :span="6">
                        <div class="title">关于我们</div>
                        <div class="text">
                            <router-link :to="{name:'About', params: {}}">关于我们</router-link>
                        </div>
                        <div class="text">
                            <router-link :to="{name:'About', params: {}}">联系我们</router-link>
                        </div>
                    </el-col>
                </el-row>
                <el-row :gutter="50" style="padding: 0 25px">
                    <el-col style="line-height: 90px;color: #949aab;border-top: 1px solid #949aab;">
                        <el-col style="line-height: 90px;color: #949aab;vertical-align: middle;border-top: 1px solid #949aab;font-size: 12px;">
                            &copy; 2020-2024 天津中创远泰物流有限公司
                            <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=12019302000123" style="vertical-align: middle;display:inline-block;text-decoration:none;height:20px;line-height:20px;">
                                <img src="~@/assets/icon-report.png" style="float:left;"/>
                                <p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#949aab;">
                                    津公网安备 12019302000123号
                                </p>
                            </a>
                            <a target="_blank" href="https://beian.miit.gov.cn" style="vertical-align: middle;display:inline-block;text-decoration:none;height:20px;line-height:20px;">
                                <p style="height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#949aab;">
                                    津ICP备2020007907号-1
                                </p>
                            </a>
                        </el-col>
                    </el-col>
                </el-row>
            </div>
        </div>
    </el-footer>
</template>

<script>
import { getCategoryList } from '@/api/api'

export default {
    name: 'Footer',
    data () {
        return {
            categoryList: []
        }
    },
    created () {
        getCategoryList({categoryCode: 'XGXWDT-1'}).then(res => {
            if (res.data.success) {
                this.categoryList = res.data.result
            }
        })
    }
}
</script>

<style lang="scss" scoped>
.el-footer {
    background-color: #152147;
    color: #333;
    text-align: center;
    height: auto!important;
    .footer-box{
        background-color: #152147;
        padding-top: 80px;
        .footer{
            width: 1200px;
            height: auto;
            margin: auto;
            .title{
                font-size: 16px;
                color: #ffffff;
                line-height: 60px;
                border-bottom: 1px solid #949aab;
                text-align: left;
                margin-bottom: 10px;
            }
            .text{
                font-size: 12px;
                color: #949aab;
                line-height: 40px;
                text-align: left;
                a{
                    text-decoration: none;
                    outline: none;
                    color: #949aab;
                    &:hover{
                        color: #ffffff;
                    }
                }
            }
        }
    }
}

</style>



// WEBPACK FOOTER //
// src/components/layouts/Footer.vue